/* VANDALISM — core interactions: mobile nav, reveal-on-scroll, AJAX cart, product page. */
(function () {
  "use strict";

  function sizeRequiredMessage(form) {
    return (form && form.dataset.sizeRequired) || "Choisis une taille pour les articles sélectionnés.";
  }

  function setSizePlaceholder(select, required) {
    var empty = select && select.querySelector('option[value=""]');
    if (!empty) return;
    var label = required ? empty.dataset.requiredLabel : empty.dataset.label;
    if (label) empty.textContent = label;
  }

  // Shakes the card, turns its picker red and opens it: the blocker has to be
  // impossible to miss, not just a line of text under the button.
  function flagMissingSize(item, focusIt) {
    var node = item.card || item.node;
    if (node) {
      node.classList.remove("is-invalid");
      void node.offsetWidth; // restart the shake on repeated attempts
      node.classList.add("is-invalid");
    }
    if (!item.select) return;
    item.select.hidden = false;
    setSizePlaceholder(item.select, true);
    if (!focusIt) return;
    item.select.focus({ preventScroll: true });
    try {
      if (typeof item.select.showPicker === "function") item.select.showPicker();
    } catch (err) {
      /* not allowed without user activation — the red state still shows */
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  /* ---------- mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var nav = document.querySelector("[data-mobile-nav]");
    var closeBtn = document.querySelector("[data-menu-close]");
    if (!toggle || !nav) return;

    function open() {
      nav.classList.add("is-open");
      document.body.classList.add("no-scroll");
      toggle.setAttribute("aria-expanded", "true");
    }
    function close() {
      nav.classList.remove("is-open");
      document.body.classList.remove("no-scroll");
      toggle.setAttribute("aria-expanded", "false");
    }
    toggle.addEventListener("click", function () {
      nav.classList.contains("is-open") ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener("click", close);
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", close);
    });
  }

  /* ---------- search drawer ---------- */
  function initSearch() {
    var drawer = document.querySelector("[data-search-drawer]");
    var overlay = document.querySelector("[data-search-overlay]");
    var input = document.querySelector("[data-search-input]");
    if (!drawer) return;

    function open(e) {
      if (e) e.preventDefault();
      drawer.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      document.body.classList.add("no-scroll");
      if (input) input.focus();
    }
    function close() {
      drawer.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-open");
      document.body.classList.remove("no-scroll");
    }

    document.querySelectorAll("[data-search-open]").forEach(function (btn) {
      btn.addEventListener("click", open);
    });
    document.querySelectorAll("[data-search-close]").forEach(function (btn) {
      btn.addEventListener("click", close);
    });
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) close();
    });

    initPredictiveSearch(drawer, input);
  }

  /* ---------- predictive search: results while typing ---------- */
  function initPredictiveSearch(drawer, input) {
    var panel = drawer.querySelector("[data-search-panel]");
    var results = drawer.querySelector("[data-search-results]");
    var status = drawer.querySelector("[data-search-status]");
    var allLink = drawer.querySelector("[data-search-all]");
    if (!input || !panel || !results) return;

    var MIN_CHARS = 2;
    var timer = null;
    var controller = null;

    function hide() {
      panel.hidden = true;
      results.innerHTML = "";
      if (status) status.textContent = "";
      if (allLink) allLink.hidden = true;
    }

    function render(products, query) {
      results.innerHTML = products
        .map(function (p) {
          var image = (p.featured_image && p.featured_image.url) || p.image;
          var cents = Math.round(parseFloat(p.price || 0) * 100);
          return (
            '<a class="search-suggest__item" href="' + encodeURI(p.url) + '">' +
            '<span class="search-suggest__media">' +
            (image
              ? '<img src="' + encodeURI(image) + (image.indexOf("?") > -1 ? "&" : "?") +
                'width=120" alt="" width="120" height="150" loading="lazy">'
              : "") +
            "</span>" +
            '<span class="search-suggest__info">' +
            '<span class="search-suggest__title">' + escapeHtml(p.title) + "</span>" +
            '<span class="search-suggest__price">' + Vandalism.formatMoney(cents) + "</span>" +
            "</span></a>"
          );
        })
        .join("");
      if (allLink) {
        allLink.href = "/search?type=product&q=" + encodeURIComponent(query);
        allLink.textContent = "Voir tous les résultats pour « " + query + " »";
        allLink.hidden = false;
      }
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      if (status) status.textContent = "Recherche…";
      panel.hidden = false;

      var url =
        "/search/suggest.json?q=" + encodeURIComponent(query) +
        "&resources[type]=product&resources[limit]=6" +
        "&resources[options][unavailable_products]=last";

      fetch(url, { signal: controller.signal })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = ((data.resources || {}).results || {}).products || [];
          if (!products.length) {
            results.innerHTML = "";
            if (allLink) allLink.hidden = true;
            if (status) status.textContent = "Aucun résultat pour « " + query + " »";
            return;
          }
          if (status) status.textContent = "";
          render(products, query);
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return; // superseded by a newer keystroke
          if (status) status.textContent = "Recherche indisponible, appuie sur Entrée.";
        });
    }

    input.addEventListener("input", function () {
      var query = input.value.trim();
      window.clearTimeout(timer);
      if (query.length < MIN_CHARS) {
        if (controller) controller.abort();
        hide();
        return;
      }
      timer = window.setTimeout(function () { search(query); }, 220);
    });

    // Closing the drawer clears the previous query's results.
    drawer.querySelectorAll("[data-search-close]").forEach(function (btn) {
      btn.addEventListener("click", hide);
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var items = document.querySelectorAll(".reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -5% 0px" }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- drag-to-scroll (horizontal rows) ---------- */
  function initDragScroll() {
    document.querySelectorAll(".drag-scroll").forEach(function (el) {
      var isDown = false, moved = false, startX = 0, scrollLeft = 0;
      el.addEventListener("pointerdown", function (e) {
        // Touch keeps native scrolling: momentum and scroll-snap beat emulation.
        if (e.pointerType === "touch") return;
        isDown = true;
        moved = false;
        el.classList.add("is-dragging");
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      });
      ["pointerup", "pointerleave", "pointercancel"].forEach(function (evt) {
        el.addEventListener(evt, function () {
          isDown = false;
          el.classList.remove("is-dragging");
        });
      });
      el.addEventListener("pointermove", function (e) {
        if (!isDown) return;
        var delta = e.pageX - el.offsetLeft - startX;
        if (Math.abs(delta) > 4) moved = true;
        if (!moved) return;
        e.preventDefault();
        el.scrollLeft = scrollLeft - delta;
      });
      // A drag must not toggle the card it happens to end on.
      el.addEventListener(
        "click",
        function (e) {
          if (!moved) return;
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        },
        true
      );
    });
  }

  /* ---------- accordion (product page) ---------- */
  function initAccordions() {
    document.querySelectorAll(".accordion-item__trigger").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var item = trigger.closest(".accordion-item");
        var panel = item.querySelector(".accordion-item__panel");
        var isOpen = item.classList.contains("is-open");
        item.parentElement.querySelectorAll(".accordion-item.is-open").forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove("is-open");
            openItem.querySelector(".accordion-item__panel").style.maxHeight = null;
          }
        });
        if (isOpen) {
          item.classList.remove("is-open");
          panel.style.maxHeight = null;
        } else {
          item.classList.add("is-open");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }

  /* ---------- product gallery ---------- */
  function initProductGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-full");
          if (main && src) main.src = src;
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- variant selection -> update hidden variant id + gallery image ---------- */
  function initVariantPickers() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var variantsJson = form.querySelector("[data-variants-json]");
      if (!variantsJson) return;
      var variants;
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (e) {
        return;
      }
      var inputs = form.querySelectorAll("[data-option-input]");
      var idField = form.querySelector("[data-variant-id]");
      var addBtn = form.querySelector("[data-add-to-cart]");
      var priceEl = document.querySelector("[data-product-price]");
      var infoWrap = form.closest(".product__info");
      var stickyBtn = infoWrap ? infoWrap.querySelector("[data-add-to-cart-sticky]") : null;
      var stickyPriceEl = infoWrap ? infoWrap.querySelector("[data-sticky-atc-price]") : null;

      function currentSelection() {
        var selected = [];
        var groups = {};
        inputs.forEach(function (input) {
          if (input.checked || input.tagName === "SELECT") {
            var pos = input.getAttribute("data-option-position");
            groups[pos] = input.value;
          }
        });
        Object.keys(groups).sort().forEach(function (k) { selected.push(groups[k]); });
        return selected;
      }

      function matchVariant() {
        var selected = currentSelection();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      // Tant que toutes les options ne sont pas choisies, la sélection est
      // incomplète — ce n'est pas la même chose qu'une variante épuisée.
      function selectionComplete() {
        var groups = {};
        inputs.forEach(function (input) {
          groups[input.getAttribute("data-option-position")] = true;
        });
        var chosen = 0;
        Object.keys(groups).forEach(function (pos) {
          var any = form.querySelector(
            "[data-option-input][data-option-position='" + pos + "']:checked"
          );
          if (any) chosen += 1;
        });
        return chosen === Object.keys(groups).length;
      }

      function refresh() {
        if (!selectionComplete()) {
          // On garde le bouton actif : le blocage se fait à la soumission, avec
          // un message et un focus, plutôt qu'un bouton mort sans explication.
          if (idField) idField.value = "";
          var addLabel = form.getAttribute("data-add-label") || "Ajouter au panier";
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = addLabel; }
          if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = addLabel; }
          return;
        }
        var variant = matchVariant();
        if (!variant) {
          var unavailableLabel = form.getAttribute("data-unavailable-label") || "Indisponible";
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = unavailableLabel; }
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = unavailableLabel; }
          return;
        }
        if (idField) idField.value = variant.id;
        var label = variant.available
          ? (form.getAttribute("data-add-label") || "Ajouter au panier")
          : (form.getAttribute("data-soldout-label") || "Épuisé");
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = label;
        }
        if (stickyBtn) {
          stickyBtn.disabled = !variant.available;
          stickyBtn.textContent = label;
        }
        if (variant.price_formatted) {
          if (priceEl) priceEl.innerHTML = variant.price_formatted;
          if (stickyPriceEl) {
            // La barre collante affiche le total de la sélection : on met à jour
            // la base, puis on laisse le widget bundle réécrire le montant, sinon
            // le prix de la variante écrase le total des upsells cochés.
            // Le JSON n'exposait que le prix formaté : sans garde-fou on écrivait
            // "undefined" ici, et le total de la barre collante repartait de zéro.
            if (typeof variant.price === "number") {
              stickyPriceEl.setAttribute("data-base-price", variant.price);
            }
            stickyPriceEl.setAttribute("data-default-html", variant.price_formatted);
            stickyPriceEl.innerHTML = variant.price_formatted;
            document.dispatchEvent(new CustomEvent("vandalism:sticky-refresh"));
          }
        }
        if (variant.featured_image) {
          var main = document.querySelector("[data-gallery-main]");
          if (main) main.src = variant.featured_image;
        }
      }

      inputs.forEach(function (input) {
        input.addEventListener("change", refresh);
      });
      refresh();
    });
  }

  /* ---------- sticky add-to-cart (mobile): shows once the real button scrolls out of view ---------- */
  function initStickyAddToCart() {
    var bar = document.querySelector("[data-sticky-atc]");
    var trigger = document.querySelector(".purchase-row");
    if (!bar || !trigger || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.classList.toggle("is-visible", !entry.isIntersecting);
    }, { rootMargin: "0px 0px -10% 0px" });
    observer.observe(trigger);
  }

  /* ---------- quantity steppers ---------- */
  function initQuantitySteppers() {
    // Delegation obligatoire : le tiroir reconstruit ses lignes en JS, donc des
    // ecouteurs poses une fois au chargement disparaissent au premier re-rendu
    // et le bouton + devient inerte.
    if (!document.body.hasAttribute("data-qty-steppers-bound")) {
      document.body.setAttribute("data-qty-steppers-bound", "");
      document.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-quantity-step]");
        if (!btn) return;
        var wrap = btn.closest("[data-quantity-selector]");
        var input = wrap && wrap.querySelector("[data-quantity-input]");
        if (!input) return;
        e.preventDefault();
        var step = parseInt(btn.getAttribute("data-quantity-step"), 10);
        // 0 est permis sur une ligne de panier : c'est la suppression.
        var floor = input.hasAttribute("data-cart-line-qty") ? 0 : 1;
        input.value = Math.max(floor, (parseInt(input.value, 10) || floor) + step);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  /* ---------- announcement bar: rotating messages + looping countdown ---- */
  function initAnnouncementBar() {
    var rotator = document.querySelector("[data-announcement-rotator]");
    if (rotator) {
      var items = rotator.querySelectorAll("[data-announcement-item]");
      if (items.length > 1) {
        var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        var index = 0;
        var delay = (parseFloat(rotator.dataset.interval) || 4) * 1000;

        window.setInterval(function () {
          var current = items[index];
          index = (index + 1) % items.length;
          var next = items[index];

          if (reduce) {
            current.hidden = true;
            next.hidden = false;
            return;
          }
          current.classList.add("is-out");
          window.setTimeout(function () {
            current.hidden = true;
            current.classList.remove("is-out");
            next.classList.add("is-out");
            next.hidden = false;
            requestAnimationFrame(function () { next.classList.remove("is-out"); });
          }, 250);
        }, delay);
      }
    }

    document.querySelectorAll("[data-countdown]").forEach(function (el) {
      var out = el.querySelector("[data-countdown-value]");
      if (!out) return;
      var hours = parseFloat(el.dataset.countdownHours) || 5;
      var cycle = hours * 3600 * 1000;

      function pad(n) { return n < 10 ? "0" + n : String(n); }

      function tick() {
        // Anchored to the epoch: the cycle restarts on its own, forever, and
        // every visitor sees the same remaining time.
        var left = Math.floor((cycle - (Date.now() % cycle)) / 1000);
        out.textContent =
          pad(Math.floor(left / 3600)) + ":" + pad(Math.floor((left % 3600) / 60)) + ":" + pad(left % 60);
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  /* ---------- UGC strip: endless scroll in both directions ---------- */
  // The block set is rendered N times; keeping the scroll position inside the
  // middle copy and jumping by exactly one set width makes the loop seamless.
  function initUgcLoop() {
    document.querySelectorAll("[data-ugc-row]").forEach(function (row) {
      var copies = parseInt(row.dataset.ugcCopies, 10) || 3;
      if (copies < 3 || row.children.length < copies) return;

      var setWidth = 0;
      var wrapping = false;

      function measure() {
        setWidth = row.scrollWidth / copies;
        if (setWidth > 0 && row.scrollLeft < 1) row.scrollLeft = setWidth;
      }

      function wrap() {
        if (wrapping || setWidth <= 0) return;
        var min = setWidth * 0.5;
        var max = setWidth * 1.5;
        if (row.scrollLeft > min && row.scrollLeft < max) return;
        wrapping = true;
        row.scrollLeft += row.scrollLeft <= min ? setWidth : -setWidth;
        // released on the next frame so this jump does not re-enter
        requestAnimationFrame(function () { wrapping = false; });
      }

      row.addEventListener("scroll", wrap, { passive: true });
      window.addEventListener("resize", measure);
      if ("ResizeObserver" in window) new ResizeObserver(measure).observe(row);
      measure();
      // images/videos settling can change scrollWidth after first paint
      window.setTimeout(measure, 600);
    });
  }

  /* ---------- UGC wall: attach and play only what is on screen ---------- */
  function initUgcVideos() {
    var videos = document.querySelectorAll("[data-ugc-video]");
    if (!videos.length) return;

    function attach(video) {
      if (video.dataset.loaded) return;
      video.src = video.dataset.src;
      video.dataset.loaded = "1";
    }

    // Sound is exclusive: unmuting one clip mutes the others.
    function setSound(video, on) {
      videos.forEach(function (other) {
        if (other === video) return;
        other.muted = true;
        syncSoundButton(other);
      });
      video.muted = !on;
      if (on) video.play().catch(function () {});
      syncSoundButton(video);
    }

    function syncSoundButton(video) {
      var card = video.closest(".ugc__screen");
      var btn = card && card.querySelector("[data-ugc-sound]");
      if (!btn) return;
      var on = btn.querySelector("[data-ugc-sound-on]");
      var off = btn.querySelector("[data-ugc-sound-off]");
      if (on) on.hidden = video.muted;
      if (off) off.hidden = !video.muted;
      btn.setAttribute("aria-pressed", String(!video.muted));
    }

    videos.forEach(function (video) {
      video.muted = true;
      syncSoundButton(video);
      var card = video.closest(".ugc__screen");
      var btn = card && card.querySelector("[data-ugc-sound]");
      if (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          attach(video);
          setSound(video, video.muted);
        });
      }
    });

    if (!("IntersectionObserver" in window)) {
      videos.forEach(attach);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            attach(video);
            video.play().catch(function () {
              /* autoplay refused (data saver, reduced motion): poster stays */
            });
          } else if (!video.paused) {
            video.pause();
            video.muted = true;
            syncSoundButton(video);
          }
        });
      },
      { rootMargin: "200px", threshold: 0.35 }
    );
    videos.forEach(function (video) { observer.observe(video); });
  }

  /* ---------- country / language pickers ---------- */
  function initLocaleSelectors() {
    document.querySelectorAll("[data-locale-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        if (select.form) select.form.submit();
      });
    });
  }

  /* ---------- collection sorting ---------- */
  function initCollectionSort() {
    var select = document.querySelector("[data-sort-by]");
    if (!select || !select.form) return;
    select.addEventListener("change", function () {
      select.form.submit();
    });
  }

  /* ---------- taille obligatoire avant tout ajout ---------- */
  // S'applique à toutes les fiches produit : aucune taille n'est cochée au
  // chargement, donc un ajout sans choix conscient devient impossible.
  function initSizeGuard() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;

    function firstIncompleteGroup() {
      var groups = form.querySelectorAll("[data-variant-group]");
      for (var i = 0; i < groups.length; i++) {
        if (!groups[i].querySelector("[data-option-input]:checked")) return groups[i];
      }
      return null;
    }

    form.addEventListener(
      "submit",
      function (e) {
        var group = firstIncompleteGroup();
        if (!group) return;
        e.preventDefault();
        e.stopPropagation();

        var errorEl = form.querySelector("[data-form-error]");
        if (errorEl) errorEl.textContent = sizeRequiredMessage(form);

        group.classList.add("is-missing");
        group.scrollIntoView({block: "center", behavior: "smooth"});
        var first = group.querySelector("[data-option-input]");
        if (first) {
          try { first.focus({preventScroll: true}); } catch (err) { first.focus(); }
        }
      },
      true
    );

    form.addEventListener("change", function (e) {
      var input = e.target.closest("[data-option-input]");
      if (!input) return;
      var group = input.closest("[data-variant-group]");
      if (group) group.classList.remove("is-missing");
      var errorEl = form.querySelector("[data-form-error]");
      if (errorEl && !firstIncompleteGroup()) errorEl.textContent = "";
    });
  }

  /* ---------- dismissable cart upsell ---------- */
  function initCartUpsellDismiss() {
    var block = document.querySelector("[data-cart-upsell]");
    if (!block) return;
    var KEY = "vandalism:cart-upsell-hidden";

    try {
      if (sessionStorage.getItem(KEY) === "1") block.hidden = true;
    } catch (err) {
      /* private mode: just leave it visible */
    }

    var closeBtn = block.querySelector("[data-cart-upsell-close]");
    if (!closeBtn) return;
    closeBtn.addEventListener("click", function () {
      block.hidden = true;
      try {
        sessionStorage.setItem(KEY, "1");
      } catch (err) {
        /* nothing to persist to */
      }
    });
  }

  /* ---------- swipe rows: a visible rail so the row reads as swipeable ------ */
  function initSwipeRails() {
    document.querySelectorAll("[data-swipe-row]").forEach(function (row) {
      var rail = document.createElement("div");
      rail.className = "swipe-rail";
      var thumb = document.createElement("span");
      thumb.className = "swipe-rail__thumb";
      rail.appendChild(thumb);
      row.insertAdjacentElement("afterend", rail);

      function update() {
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 2) {
          rail.hidden = true;
          return;
        }
        rail.hidden = false;
        var widthPct = Math.max(12, (row.clientWidth / row.scrollWidth) * 100);
        thumb.style.width = widthPct + "%";
        thumb.style.left = (row.scrollLeft / max) * (100 - widthPct) + "%";
      }

      row.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      // The popup's row is filled in later, so re-measure when it changes.
      new MutationObserver(update).observe(row, { childList: true });
      update();
    });
  }

  /* ---------- bundle card state (checkbox + required size) ---------- */
  // One reader shared by the live preview, the popup and the submit path.
  function readBundleCard(check) {
    var card = check.closest("[data-bundle-card]");
    var select = card ? card.querySelector("[data-bundle-item-size]") : null;
    var needsSize = check.dataset.needsSize === "true";
    var price = parseInt(check.dataset.price, 10) || 0;
    var image = check.dataset.image;
    var option = select && select.value ? select.selectedOptions[0] : null;
    if (option) {
      price = parseInt(option.dataset.price, 10) || price;
      // Colour variants carry their own photo: "Rose / XL" shows the pink one.
      if (option.dataset.image) image = option.dataset.image;
    }
    return {
      id: needsSize ? (select ? select.value : "") : check.dataset.id,
      title: check.dataset.title,
      price: price,
      image: image,
      checked: check.checked,
      needsSize: needsSize,
      card: card,
      select: select,
      check: check,
    };
  }

  // Reveals the size picker only once the item is ticked, and keeps the card's
  // displayed price in sync with the chosen variant.
  function syncBundleCard(check) {
    if (check.checked === false && check.dataset.needsSize === "true") {
      var ownSelect = check.closest("[data-bundle-card]");
      ownSelect = ownSelect && ownSelect.querySelector("[data-bundle-item-size]");
      if (ownSelect) ownSelect.value = "";
    }
    var item = readBundleCard(check);
    if (item.select) {
      item.select.hidden = !check.checked;
      setSizePlaceholder(item.select, false);
    }
    if (!item.card) return;

    item.card.classList.remove("is-invalid");
    var priceEl = item.card.querySelector("[data-bundle-item-price]");
    if (priceEl) priceEl.textContent = Vandalism.formatMoney(item.price);

    var imgEl = item.card.querySelector(".bundle-widget__card-media img");
    if (imgEl) {
      var option = item.select && item.select.value ? item.select.selectedOptions[0] : null;
      var next = (option && option.dataset.image) || imgEl.dataset.defaultSrc;
      if (next && imgEl.getAttribute("src") !== next) imgEl.setAttribute("src", next);
    }
  }

  /* ---------- PDP bundle live preview (gauge + estimated total) ---------- */
  function initBundlePreview() {
    var widgets = document.querySelectorAll("[data-bundle-cards]");
    if (!widgets.length) return;

    function update(widget) {
      var wrap = widget.closest(".product__info");
      var wrapper = widget.closest(".bundle-widget");
      if (!wrap || !wrapper) return;

      var checks = widget.querySelectorAll("[data-bundle-item-check]");
      var checkedItems = Array.prototype.filter
        .call(checks, function (el) { return el.checked; })
        .map(readBundleCard);
      var qtyInput = wrap.querySelector("[data-quantity-input]");
      var productQty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var extraTotal = checkedItems.reduce(function (sum, item) { return sum + item.price; }, 0);

      var summaryEl = wrapper.querySelector("[data-bundle-summary]");
      if (summaryEl) {
        if (!summaryEl.hasAttribute("data-default-text")) {
          summaryEl.setAttribute("data-default-text", summaryEl.textContent);
        }
        if (checkedItems.length) {
          summaryEl.textContent =
            checkedItems.length + (checkedItems.length > 1 ? " pièces sélectionnées" : " pièce sélectionnée") +
            " · +" + Vandalism.formatMoney(extraTotal);
        } else {
          summaryEl.textContent = summaryEl.getAttribute("data-default-text");
        }
      }

      // Barre collante mobile : elle affiche le total de la sélection, puis
      // ouvre sur le palier suivant tant qu'il reste à portée.
      var stickyPrice = wrap.querySelector("[data-sticky-atc-price]");
      var stickyNote = wrap.querySelector("[data-sticky-atc-note]");
      if (stickyPrice) {
        if (!stickyPrice.hasAttribute("data-default-html")) {
          stickyPrice.setAttribute("data-default-html", stickyPrice.innerHTML);
        }
        var base = parseInt(stickyPrice.getAttribute("data-base-price"), 10) || 0;
        if (checkedItems.length) {
          var pieces = checkedItems.length + productQty;

          // Prix de chaque pièce de la sélection, pour pouvoir appliquer la
          // remise du palier atteint plutôt que d'afficher un total plein tarif
          // que le panier contredira.
          var prices = [];
          for (var q = 0; q < productQty; q++) prices.push(base);
          checkedItems.forEach(function (item) { prices.push(item.price); });
          var gross = prices.reduce(function (sum, v) { return sum + v; }, 0);

          var net = gross;
          var tiersForPrice = Vandalism.Cart ? Vandalism.Cart.getTiers() : null;
          if (tiersForPrice) {
            // On ne prévisualise la remise que si la sélection seule atteint le
            // palier : sinon elle porterait peut-être sur un article du panier.
            var reached = tiersForPrice.filter(function (t) {
              return t.reward !== false && t.discount > 0 && prices.length >= t.qty;
            }).pop();
            if (reached && reached.scope === "cheapest_item") {
              var cheapest = Math.min.apply(null, prices);
              net = gross - Math.round((cheapest * reached.discount) / 100);
            }
          }

          var amount =
            net < gross
              ? '<s class="sticky-atc__was">' + Vandalism.formatMoney(gross) + "</s> " +
                '<span class="sticky-atc__total">' + Vandalism.formatMoney(net) + "</span>"
              : '<span class="sticky-atc__total">' + Vandalism.formatMoney(gross) + "</span>";

          stickyPrice.innerHTML =
            amount + ' <span class="sticky-atc__pieces">' + pieces + " pièces</span>";
        } else {
          stickyPrice.innerHTML = stickyPrice.getAttribute("data-default-html");
        }
      }
      if (stickyNote && Vandalism.Cart) {
        var noteTiers = Vandalism.Cart.getTiers();
        var noteQty = 0;
        if (noteTiers) {
          var noteCart = Vandalism.Cart.lastCart;
          var noteOfferEl = wrap.querySelector("[data-product-eligible]");
          var noteCounts = !noteOfferEl || noteOfferEl.dataset.productEligible !== "false";
          noteQty =
            (noteCart ? Vandalism.Cart.eligibleCount(noteCart) : 0) +
            (noteCounts ? productQty : 0) +
            checkedItems.filter(function (item) {
              return Vandalism.Cart.isEligible(parseInt(item.check.dataset.productId, 10));
            }).length;
          var nextTier = noteTiers.filter(function (t) {
            return t.reward !== false && noteQty < t.qty;
          })[0];
          if (nextTier && noteQty > 0) {
            var left = nextTier.qty - noteQty;
            stickyNote.innerHTML =
              "+" + left + " " + Vandalism.Cart.progressUnit(left) +
              " → <strong>" + nextTier.label + "</strong>";
            stickyNote.hidden = false;
          } else {
            stickyNote.hidden = true;
          }
        }
      }

      var progressEls = wrap.querySelectorAll("[data-cart-progress]");
      if (progressEls.length && Vandalism.Cart) {
        var tiers = Vandalism.Cart.getTiers();
        if (tiers) {
          // Preview what the cart would become — counting only what the offer
          // actually rewards, so the gauge never promises more than it gives.
          var cart = Vandalism.Cart.lastCart;
          var cartQty = cart ? Vandalism.Cart.eligibleCount(cart) : 0;
          var offerEl = wrap.querySelector("[data-product-eligible]");
          var productCounts = !offerEl || offerEl.dataset.productEligible !== "false";
          var eligibleChecked = checkedItems.filter(function (item) {
            return Vandalism.Cart.isEligible(parseInt(item.check.dataset.productId, 10));
          }).length;
          var previewQty = cartQty + (productCounts ? productQty : 0) + eligibleChecked;
          Vandalism.Cart.applyProgressToElements(
            progressEls, previewQty, tiers, previewQty > cartQty);
        }
      }
    }

    function updateAll() {
      widgets.forEach(update);
    }

    // Une variante vient d'être choisie : le total collant doit être recalculé.
    document.addEventListener("vandalism:sticky-refresh", updateAll);

    // Cartes d'offre des PDP doudoune : la carte « duo » révèle le sélecteur de
    // pantalon et déverrouille les cadeaux. La carte « seule » remet tout à plat.
    var tiersBlock = document.querySelector("[data-offer-tiers]");
    if (tiersBlock) {
      var expand = document.querySelector("[data-offer-body]");
      // Le bloc cadeaux vit hors des cartes (après le sélecteur de pantalon) :
      // le chercher dans tiersBlock renvoyait null et rien ne se déverrouillait.
      var giftsBlock = document.querySelector("[data-offer-gifts]");
      var giftsTitle = document.querySelector("[data-offer-gifts-title]");
      var lockedTitle = giftsTitle ? giftsTitle.textContent.trim() : "";
      var unlockedTitle =
        (document.querySelector("[data-bundle-gifts]") &&
          document.querySelector("[data-bundle-gifts]").getAttribute("data-unlocked-title")) ||
        lockedTitle;

      var applyTier = function (value) {
        var duo = value === "duo";
        tiersBlock.querySelectorAll("[data-offer-tier]").forEach(function (card) {
          card.classList.toggle("is-selected", card.dataset.offerTier === value);
        });
        if (expand) expand.hidden = !duo;
        // Choisir l'offre montre les cadeaux, cadenassés. C'est le choix d'un
        // pantalon qui les déverrouille : la récompense suit l'action, pas l'intention.
        syncGifts();
        // Revenir sur « la doudoune seule » ne doit pas laisser un pantalon coché.
        if (!duo) {
          document.querySelectorAll("[data-bundle-item-check]").forEach(function (el) {
            if (el.checked) {
              el.checked = false;
              el.dispatchEvent(new Event("change", {bubbles: true}));
            }
          });
        }
        updateAll();
        syncAddButtons();
      };

      var lockedNameValue = null;
      function lockedName() {
        if (lockedNameValue === null) {
          var first = document.querySelector(".offer-gift__name");
          lockedNameValue = first ? first.textContent.trim() : "";
        }
        return lockedNameValue;
      }
      lockedName();

      // Offre duo sans pantalon choisi : l'ajout au panier n'a pas de sens, on le
      // bloque et on dit pourquoi plutôt que de laisser passer un panier incomplet.
      function duoIncomplete() {
        var input = tiersBlock.querySelector("input[name='offer-tier']:checked");
        if (!input || input.value !== "duo") return false;
        // Plus aucun pantalon proposé (tous déjà au panier) : exiger un choix
        // impossible reviendrait à bloquer la fiche pour de bon.
        if (!document.querySelectorAll("[data-bundle-item-check]").length) return false;
        return document.querySelectorAll("[data-bundle-item-check]:checked").length === 0;
      }

      // Après un ajout, les cartes cochées disparaissent : l'offre a été prise,
      // la carte repasse sur « la doudoune seule » au lieu de rester duo sans
      // pantalon et de bloquer tous les ajouts suivants.
      document.addEventListener("vandalism:added", function () {
        var solo = tiersBlock.querySelector("input[name='offer-tier'][value='solo']");
        if (solo && !solo.checked) {
          solo.checked = true;
          applyTier("solo");
        } else {
          syncAddButtons();
          syncGifts();
        }
      });

      function syncGifts() {
        if (!giftsBlock) return;
        var input = tiersBlock.querySelector("input[name='offer-tier']:checked");
        var duo = input && input.value === "duo";
        var unlocked = duo && document.querySelectorAll("[data-bundle-item-check]:checked").length > 0;
        giftsBlock.classList.toggle("is-unlocked", unlocked);
        if (giftsTitle) giftsTitle.textContent = unlocked ? unlockedTitle : lockedTitle;
        giftsBlock.querySelectorAll(".offer-gift__name").forEach(function (el) {
          el.textContent = unlocked ? el.getAttribute("data-real-name") : lockedName();
        });
      }

      function syncAddButtons() {
        var blocked = duoIncomplete();
        document.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
          btn.classList.toggle("is-blocked", blocked);
        });
      }

      document.addEventListener("change", function (e) {
        if (e.target.closest("[data-bundle-item-check]")) {
          syncAddButtons();
          syncGifts();
        }
      });

      var pform = document.querySelector("[data-product-form]");
      if (pform) {
        pform.addEventListener(
          "submit",
          function (e) {
            if (!duoIncomplete()) return;
            e.preventDefault();
            e.stopPropagation();
            var errorEl = pform.querySelector("[data-form-error]");
            if (errorEl) {
              errorEl.textContent =
                tiersBlock.getAttribute("data-incomplete-message") ||
                "Choisis un pantalon pour valider cette offre.";
            }
            if (expand && !expand.hidden) {
              expand.scrollIntoView({block: "center", behavior: "smooth"});
            }
          },
          true
        );
      }

      tiersBlock.addEventListener("change", function (e) {
        var input = e.target.closest("input[name='offer-tier']");
        if (input) applyTier(input.value);
      });
      applyTier("solo");
    }

    // Le bouton de paiement express part droit au checkout : il ignore la taille
    // et les upsells cochés. On l'intercepte pour ajouter la sélection au panier,
    // puis on le relance.
    var guard = document.querySelector("[data-express-guard]");
    if (guard) {
      var expressReady = false;
      guard.addEventListener(
        "click",
        function (e) {
          if (expressReady) return;
          var form = document.querySelector("[data-product-form]");
          if (!form) return;
          var idField = form.querySelector("[data-variant-id]");
          var errorEl = form.querySelector("[data-form-error]");

          if (!idField || !idField.value) {
            e.preventDefault();
            e.stopPropagation();
            if (errorEl) errorEl.textContent = sizeRequiredMessage(form);
            return;
          }

          var picked = [];
          widgets.forEach(function (widget) {
            widget.querySelectorAll("[data-bundle-item-check]").forEach(function (el) {
              if (el.checked) picked.push(readBundleCard(el));
            });
          });
          if (!picked.length) return;

          var missing = picked.filter(function (item) { return !item.id; });
          if (missing.length) {
            e.preventDefault();
            e.stopPropagation();
            if (errorEl) errorEl.textContent = sizeRequiredMessage(form);
            missing.forEach(function (item, i) { flagMissingSize(item, i === 0); });
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          fetch("/cart/add.js", {
            method: "POST",
            headers: {"Content-Type": "application/json", Accept: "application/json"},
            body: JSON.stringify({
              items: picked.map(function (item) { return {id: item.id, quantity: 1}; }),
            }),
          }).then(function () {
            expressReady = true;
            var btn = guard.querySelector("button, [role='button']");
            if (btn) btn.click();
            else guard.click();
          });
        },
        true
      );
    }

    widgets.forEach(function (widget) {
      widget.addEventListener("change", function (e) {
        var check = e.target.closest("[data-bundle-item-check]");
        if (check) syncBundleCard(check);
        var select = e.target.closest("[data-bundle-item-size]");
        if (select) {
          var card = select.closest("[data-bundle-card]");
          var own = card && card.querySelector("[data-bundle-item-check]");
          if (own) syncBundleCard(own);
        }
        update(widget);
      });
    });
    document.addEventListener("change", function (e) {
      if (e.target.closest("[data-quantity-input]")) updateAll();
    });

    window.Vandalism = window.Vandalism || {};
    window.Vandalism.refreshBundlePreview = updateAll;
    updateAll();
  }

  /* ---------- AJAX cart ---------- */
  var Cart = {
    drawer: null,
    overlay: null,

    init: function () {
      this.drawer = document.querySelector("[data-cart-drawer]");
      this.overlay = document.querySelector("[data-cart-overlay]");
      if (!this.drawer) return;

      document.querySelectorAll("[data-cart-open]").forEach(
        function (btn) { btn.addEventListener("click", this.open.bind(this)); }.bind(this)
      );
      document.querySelectorAll("[data-cart-close]").forEach(
        function (btn) { btn.addEventListener("click", this.close.bind(this)); }.bind(this)
      );
      if (this.overlay) this.overlay.addEventListener("click", this.close.bind(this));

      document.addEventListener("submit", this.handleFormSubmit.bind(this));
      document.addEventListener(
        "click",
        function (e) {
          var el = e.target.closest("[data-cart-line-remove]");
          if (el) {
            e.preventDefault();
            this.changeLine(el.getAttribute("data-cart-line-remove"), 0);
          }
        }.bind(this)
      );
      document.addEventListener(
        "click",
        function (e) {
          var el = e.target.closest("[data-quick-add]");
          if (el) {
            e.preventDefault();
            this.quickAdd(el.getAttribute("data-quick-add"), el);
          }
        }.bind(this)
      );
      document.addEventListener(
        "change",
        function (e) {
          var el = e.target.closest("[data-cart-line-qty]");
          if (el) this.changeLine(el.getAttribute("data-cart-line-qty"), parseInt(el.value, 10) || 0);
        }.bind(this)
      );

      // Règle unique : un ajout au panier ouvre le tiroir. Chaque chemin d'ajout
      // (formulaire produit, popup bundle, bouton + des upsells) émet l'événement,
      // plutôt que d'appeler open() chacun de son côté et d'en oublier un.
      document.addEventListener(
        "vandalism:added",
        function () {
          this.refresh(function () { this.open(); }.bind(this));
        }.bind(this)
      );

      this.refresh();
    },

    // Taille déjà retenue par le client : on reprend celle de la première ligne
    // éligible du panier (son jean), sinon celle de la première ligne.
    preferredSize: function () {
      var cart = this.lastCart;
      if (!cart || !cart.items || !cart.items.length) return "";
      var lines = cart.items.slice();
      var eligible = lines.filter(function (item) {
        return this.isEligible(item.product_id);
      }.bind(this));
      var source = (eligible.length ? eligible : lines)[0];
      if (!source) return "";
      if (source.options_with_values) {
        for (var i = 0; i < source.options_with_values.length; i++) {
          var o = source.options_with_values[i];
          if (/taille|size/i.test(o.name || "")) return String(o.value || "");
        }
      }
      return String(source.variant_title || "").split(" / ")[0];
    },

    // Renvoie la variante à ajouter : même taille que le panier si elle existe
    // et qu'elle est disponible, sinon la première disponible.
    pickVariant: function (btn, fallbackId) {
      if (!btn) return fallbackId;
      var variants;
      try { variants = JSON.parse(btn.getAttribute("data-variants") || "[]"); }
      catch (err) { variants = []; }
      if (!variants.length) return fallbackId;

      var wanted = this.preferredSize().trim().toLowerCase();
      if (wanted) {
        var match = variants.filter(function (v) {
          return v.available && String(v.title).trim().toLowerCase() === wanted;
        })[0];
        if (match) return String(match.id);
      }
      var firstAvailable = variants.filter(function (v) { return v.available; })[0];
      return firstAvailable ? String(firstAvailable.id) : fallbackId;
    },

    quickAdd: function (variantId, btn) {
      var id = this.pickVariant(btn, variantId);
      var self = this;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          // Un ajout refusé renvoyait un 4xx avalé en silence : rien ne bougeait
          // et le client n'avait aucun retour.
          if (data && data.status) {
            if (btn) {
              btn.classList.add("is-error");
              btn.setAttribute("title", data.description || data.message || "Indisponible");
              window.setTimeout(function () { btn.classList.remove("is-error"); }, 2000);
            }
            return;
          }
          self.refresh(function () { self.open(); });
          document.dispatchEvent(new CustomEvent("vandalism:added"));
        });
    },

    open: function (e) {
      if (e) e.preventDefault();
      this.drawer.classList.add("is-open");
      if (this.overlay) this.overlay.classList.add("is-open");
      document.body.classList.add("no-scroll");
    },
    close: function () {
      this.drawer.classList.remove("is-open");
      if (this.overlay) this.overlay.classList.remove("is-open");
      document.body.classList.remove("no-scroll");
    },

    handleFormSubmit: function (e) {
      var form = e.target.closest("[data-product-form]");
      if (!form) return;
      e.preventDefault();

      var infoWrap = form.closest(".product__info");
      var checks = infoWrap ? infoWrap.querySelectorAll("[data-bundle-item-check]") : [];
      var modal = document.querySelector("[data-bundle-modal]");
      var errorEl = form.querySelector("[data-form-error]");
      var bundleItems = Array.prototype.map.call(checks, readBundleCard);

      // Items ticked on the page are already decided: they go in with the
      // product. The popup draws from its own pool (a different collection),
      // so the row can push pants while the popup cross-sells jackets.
      var picked = bundleItems.filter(function (item) { return item.checked; });

      // A ticked upsell with no variant chosen blocks the add: no silent default size.
      var missingSize = picked.filter(function (item) { return !item.id; });
      if (missingSize.length) {
        if (missingSize[0].card) {
          missingSize[0].card.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
        }
        missingSize.forEach(function (item, i) { flagMissingSize(item, i === 0); });
        if (errorEl) errorEl.textContent = sizeRequiredMessage(form);
        return;
      }
      if (errorEl) errorEl.textContent = "";

      var pool = document.querySelectorAll("[data-bundle-modal-source] [data-bundle-item-check]");
      var offers = Array.prototype.map.call(pool, readBundleCard);
      if (offers.length && modal) {
        this.openBundleModal(modal, offers, form, picked);
        return;
      }
      this.submitAdd(form, picked);
    },

    openBundleModal: function (modal, offers, form, preselected) {
      var itemsEl = modal.querySelector("[data-bundle-modal-items]");
      var countEl = modal.querySelector("[data-bundle-modal-count]");
      var totalEl = modal.querySelector("[data-bundle-modal-total]");
      var errorEl = modal.querySelector("[data-bundle-modal-error]");
      var accept = modal.querySelector("[data-bundle-modal-accept]");
      var decline = modal.querySelector("[data-bundle-modal-decline]");
      var closeEls = modal.querySelectorAll("[data-bundle-modal-close]");
      var acceptTemplate = accept.getAttribute("data-label-template") || accept.textContent;
      var self = this;


      // Own state: the popup starts from scratch, the page's ticks are already
      // banked in `preselected`.
      var items = offers.map(function (offer) {
        return {
          title: offer.title,
          image: offer.image,
          basePrice: offer.price,
          price: offer.price,
          needsSize: offer.needsSize,
          id: offer.needsSize ? "" : offer.id,
          selectTemplate: offer.select,
          checked: false,
          node: null,
          select: null,
        };
      });

      function buildItem(item, idx) {
        var wrap = document.createElement("div");
        wrap.className = "modal__bundle-item";
        wrap.setAttribute("data-bundle-card", "");

        var label = document.createElement("label");
        label.className = "modal__bundle-item-pick";

        var input = document.createElement("input");
        input.type = "checkbox";
        input.className = "modal__bundle-item-check";
        input.setAttribute("data-bundle-modal-item-check", "");
        input.setAttribute("data-idx", String(idx));

        var tick = document.createElement("span");
        tick.className = "modal__bundle-item-tick";
        tick.setAttribute("aria-hidden", "true");
        tick.textContent = "✓";

        var media = document.createElement("span");
        media.className = "modal__bundle-item-media";
        var img = document.createElement("img");
        img.src = item.image;
        img.alt = "";
        img.width = 200;
        img.height = 250;
        img.loading = "lazy";
        media.appendChild(img);

        var title = document.createElement("span");
        title.className = "modal__bundle-item-title";
        title.textContent = item.title;

        var price = document.createElement("span");
        price.className = "modal__bundle-item-price";
        price.textContent = Vandalism.formatMoney(item.price);

        label.appendChild(input);
        label.appendChild(tick);
        label.appendChild(media);
        label.appendChild(title);
        label.appendChild(price);
        wrap.appendChild(label);

        // Reuse the card's own size picker rather than rebuilding its options.
        if (item.selectTemplate) {
          var select = item.selectTemplate.cloneNode(true);
          select.hidden = true;
          select.value = "";
          wrap.appendChild(select);
          item.select = select;
        }
        item.node = wrap;
        item.priceEl = price;
        item.imgEl = img;
        item.defaultImage = item.image;
        return wrap;
      }

      function updateSummary() {
        var checkedItems = items.filter(function (item) { return item.checked; });
        var total = checkedItems.reduce(function (sum, item) { return sum + item.price; }, 0);
        if (countEl) {
          countEl.textContent =
            checkedItems.length + (checkedItems.length > 1 ? " pièces sélectionnées" : " pièce sélectionnée");
        }
        if (totalEl) totalEl.textContent = "+" + Vandalism.formatMoney(total);
        if (accept) {
          accept.textContent = acceptTemplate.replace("__TOTAL__", Vandalism.formatMoney(total));
          accept.disabled = checkedItems.length === 0;
        }
      }

      function clearError() {
        if (!errorEl) return;
        errorEl.hidden = true;
        errorEl.textContent = "";
        items.forEach(function (item) {
          if (item.node) item.node.classList.remove("is-invalid");
          if (item.select) setSizePlaceholder(item.select, false);
        });
      }

      function onChange(e) {
        var check = e.target.closest("[data-bundle-modal-item-check]");
        if (check) {
          var item = items[parseInt(check.getAttribute("data-idx"), 10)];
          item.checked = check.checked;
          if (item.select) {
            item.select.hidden = !check.checked;
            if (!check.checked) {
              item.select.value = "";
              item.id = "";
              item.price = item.basePrice;
              item.image = item.defaultImage;
              item.priceEl.textContent = Vandalism.formatMoney(item.price);
              if (item.imgEl && item.defaultImage) item.imgEl.src = item.defaultImage;
            }
          }
          clearError();
          updateSummary();
          return;
        }
        var select = e.target.closest("[data-bundle-item-size]");
        if (select) {
          var owner = items.filter(function (i) { return i.select === select; })[0];
          if (owner) {
            owner.id = select.value;
            var opt = select.selectedOptions[0];
            owner.price = (opt && parseInt(opt.dataset.price, 10)) || owner.basePrice;
            owner.priceEl.textContent = Vandalism.formatMoney(owner.price);
            if (opt && opt.dataset.image) {
              owner.image = opt.dataset.image;
              if (owner.imgEl) owner.imgEl.src = owner.image;
            }
            clearError();
            updateSummary();
          }
        }
      }

      if (itemsEl) {
        itemsEl.innerHTML = "";
        items.forEach(function (item, idx) { itemsEl.appendChild(buildItem(item, idx)); });
        itemsEl.scrollLeft = 0;
      }
      clearError();
      updateSummary();
      modal.hidden = false;
      document.body.classList.add("no-scroll");
      if (itemsEl) itemsEl.addEventListener("change", onChange);

      function cleanup() {
        modal.hidden = true;
        document.body.classList.remove("no-scroll");
        if (itemsEl) itemsEl.removeEventListener("change", onChange);
        accept.removeEventListener("click", onAccept);
        decline.removeEventListener("click", onDecline);
        closeEls.forEach(function (el) { el.removeEventListener("click", onDecline); });
      }
      function onAccept() {
        var chosenHere = items.filter(function (item) { return item.checked; });
        var missingSize = chosenHere.filter(function (item) { return !item.id; });
        if (missingSize.length) {
          if (missingSize[0].node) {
            missingSize[0].node.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
          }
          missingSize.forEach(function (item, i) { flagMissingSize(item, i === 0); });
          if (errorEl) {
            errorEl.textContent = sizeRequiredMessage(form);
            errorEl.hidden = false;
          }
          return;
        }
        cleanup();
        self.submitAdd(form, (preselected || []).concat(chosenHere));
      }
      function onDecline() {
        cleanup();
        self.submitAdd(form, preselected || []);
      }
      accept.addEventListener("click", onAccept);
      decline.addEventListener("click", onDecline);
      closeEls.forEach(function (el) { el.addEventListener("click", onDecline); });
    },

    submitAdd: function (form, extraItems) {
      var addBtn = form.querySelector("[data-add-to-cart]");
      var formData = new FormData(form);
      var items = [
        {
          id: formData.get("id"),
          quantity: parseInt(formData.get("quantity"), 10) || 1,
        },
      ];
      if (extraItems && extraItems.length) {
        extraItems.forEach(function (item) {
          items.push({ id: item.id, quantity: 1 });
        });
      }

      // Offre duo remplie : les cadeaux partent avec. Sans eux dans le panier,
      // la remise Shopify n'a rien sur quoi s'appliquer et l'offre n'existe pas.
      var giftsEl = document.querySelector("[data-offer-gifts][data-gift-variants]");
      if (giftsEl && giftsEl.classList.contains("is-unlocked")) {
        (giftsEl.getAttribute("data-gift-variants") || "")
          .split(",")
          .forEach(function (id) {
            id = id.trim();
            if (!id) return;
            var already = items.some(function (it) { return String(it.id) === id; });
            if (!already) items.push({ id: id, quantity: 1 });
          });
      }

      if (addBtn) { addBtn.disabled = true; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { return res.json(); })
        .then(
          function (data) {
            if (data.status) {
              var errorEl = form.querySelector("[data-form-error]");
              if (errorEl) errorEl.textContent = data.description || data.message;
              if (addBtn) addBtn.disabled = false;
              return;
            }
            if (extraItems && extraItems.length) {
              extraItems.forEach(function (item) {
                var check = document.querySelector('[data-bundle-item-check][data-id="' + item.id + '"]');
                var card = check && check.closest(".bundle-widget__card");
                if (card) card.remove();
              });
              if (window.Vandalism.refreshBundlePreview) window.Vandalism.refreshBundlePreview();
            }
            this.refresh(function () { this.open(); }.bind(this));
            if (addBtn) addBtn.disabled = false;
            document.dispatchEvent(new CustomEvent("vandalism:added"));
          }.bind(this)
        )
        .catch(function () { if (addBtn) addBtn.disabled = false; });
    },

    updateProgress: function (cart) {
      var tiers = this.getTiers();
      var progressEls = document.querySelectorAll("[data-cart-progress]");
      if (!tiers || !progressEls.length) return;
      this.applyProgressToElements(progressEls, this.eligibleCount(cart), tiers);
    },

    // Product ids the offer applies to, published by the cart drawer.
    eligibleIds: function () {
      if (this._eligibleIds !== undefined) return this._eligibleIds;
      // Paliers propres à la PDP : toute pièce compte, le filtre pantalons ne
      // s'applique plus.
      if (document.querySelector("[data-cart-tiers-product]")) {
        this._eligibleIds = null;
        return null;
      }
      var el = document.querySelector("[data-cart-eligible]");
      this._eligibleIds = null;
      if (el) {
        try {
          var data = JSON.parse(el.textContent);
          if (data.ids && data.ids.length) {
            this._eligibleIds = {};
            data.ids.forEach(function (id) { this._eligibleIds[id] = true; }.bind(this));
          }
        } catch (err) {
          /* keep null: fall back to counting every line */
        }
      }
      return this._eligibleIds;
    },

    isEligible: function (productId) {
      var ids = this.eligibleIds();
      return !ids || !!ids[productId];
    },

    // Only eligible lines move the gauge; without a list, every line counts.
    eligibleCount: function (cart) {
      var ids = this.eligibleIds();
      if (!ids || !cart.items) return cart.item_count;
      var self = this;
      return cart.items.reduce(function (sum, item) {
        return self.isEligible(item.product_id) ? sum + item.quantity : sum;
      }, 0);
    },

    // Reveals the reward pickers as tiers unlock: the jewel row at tier 2, the
    // free-product row at tier 3.
    updateRewardPickers: function (cart) {
      if (!this.drawer) return;
      var tiers = this.getTiers() || [];
      var rewardTiers = tiers.filter(function (t) { return t.reward !== false; });
      if (rewardTiers.length < 2) return;

      var jewelQty = rewardTiers[0].qty;
      var giftQty = rewardTiers[rewardTiers.length - 1].qty;

      var giftRow = this.drawer.querySelector("[data-cart-gift]");
      if (giftRow) giftRow.hidden = cart.item_count < giftQty;

      var heading = this.drawer.querySelector("[data-cart-upsell-heading]");
      if (heading) {
        var unlocked = heading.dataset.unlockedHeading;
        heading.textContent =
          cart.item_count >= jewelQty && unlocked ? unlocked : heading.dataset.defaultHeading;
      }
    },

    // Shows what Shopify actually took off: the original total struck through,
    // the real total, and the discount's own name. No projection — the money on
    // screen is always the money at checkout.
    updateRewardTotal: function (cart) {
      if (!this.drawer) return;
      var rewardEl = this.drawer.querySelector("[data-cart-reward]");
      var subtotalRow = this.drawer.querySelector(".cart-drawer__subtotal");
      var subtotalEl = this.drawer.querySelector("[data-cart-subtotal]");
      if (!rewardEl || !subtotalRow) return;

      if (!cart.total_discount || cart.total_price <= 0) {
        rewardEl.hidden = true;
        subtotalRow.classList.remove("is-struck");
        if (subtotalEl) subtotalEl.textContent = Vandalism.formatMoney(cart.total_price);
        return;
      }

      // Name the discount as Shopify names it, falling back to the reached tier.
      var title = "";
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (a) {
          if (!title && a.amount > 0 && a.discount_application) title = a.discount_application.title || "";
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        if (!title) title = d.title || "";
      });
      if (!title) {
        var tier = (this.getTiers() || []).filter(function (t) {
          return t.reward !== false;
        }).pop();
        title = tier ? tier.label : "";
      }

      var original = cart.original_total_price || cart.total_price + cart.total_discount;
      var labelEl = rewardEl.querySelector("[data-cart-reward-label]");
      var valueEl = rewardEl.querySelector("[data-cart-reward-value]");
      if (labelEl) labelEl.textContent = title + " · −" + Vandalism.formatMoney(cart.total_discount);
      if (valueEl) valueEl.textContent = Vandalism.formatMoney(cart.total_price);
      if (subtotalEl) subtotalEl.textContent = Vandalism.formatMoney(original);
      rewardEl.hidden = false;
      subtotalRow.classList.add("is-struck");
    },

    // Le mot employé dans le message de la jauge, réglable dans le thème :
    // « produit » ne disait rien, l'offre porte sur les jeans.
    progressUnit: function (count) {
      var el =
        document.querySelector("[data-cart-tiers-product]") ||
        document.querySelector("[data-cart-tiers]");
      var one = (el && el.getAttribute("data-unit")) || "jean";
      var many = (el && el.getAttribute("data-unit-plural")) || one + "s";
      return count > 1 ? many : one;
    },

    getTiers: function () {
      // Une PDP peut imposer ses propres paliers (offre croisée sur les doudounes) ;
      // sinon on retombe sur ceux du panier.
      var configEl =
        document.querySelector("[data-cart-tiers-product]") ||
        document.querySelector("[data-cart-tiers]");
      if (!configEl) return null;
      try {
        var tiers = JSON.parse(configEl.textContent);
        return tiers.length ? tiers : null;
      } catch (err) {
        return null;
      }
    },

    // `projected` : le total inclut ce qui n'est pas encore au panier (le produit
    // regardé, les upsells cochés). La jauge bouge donc à chaque case cochée, et
    // le message le dit au lieu d'annoncer une récompense déjà acquise.
    applyProgressToElements: function (progressEls, qty, tiers, projected) {
      // Steps sit at equal distances on the track, so the fill is interpolated
      // segment by segment rather than scaled against the top threshold.
      var lastIndex = tiers.length - 1;
      var pct;
      if (qty <= tiers[0].qty) {
        pct = 0;
      } else if (qty >= tiers[lastIndex].qty) {
        pct = 100;
      } else {
        var seg = 0;
        for (var i = 0; i < lastIndex; i++) {
          if (qty >= tiers[i].qty && qty < tiers[i + 1].qty) {
            seg = i;
            break;
          }
        }
        var span = tiers[seg + 1].qty - tiers[seg].qty;
        var within = span > 0 ? (qty - tiers[seg].qty) / span : 0;
        pct = ((seg + within) / lastIndex) * 100;
      }
      var next = tiers.filter(function (t) { return t.reward !== false && qty < t.qty; })[0];


      // Index of the highest reward step reached, used to detect a new unlock.
      var reachedIndex = -1;
      tiers.forEach(function (t, i) {
        if (qty >= t.qty && t.reward !== false) reachedIndex = i;
      });

      progressEls.forEach(function (progressEl) {
        var fill = progressEl.querySelector("[data-cart-progress-fill]");
        if (fill) fill.style.width = pct + "%";
        // Jauge a zero : on l'anime pour signaler qu'elle attend d'etre remplie.
        progressEl.classList.toggle("is-empty", pct <= 0);

        var dots = progressEl.querySelectorAll("[data-cart-progress-dot]");
        dots.forEach(function (dot, i) {
          dot.classList.toggle("is-reached", qty >= tiers[i].qty);
        });

        var labels = progressEl.querySelectorAll(".cart-progress__labels span");
        labels.forEach(function (label, i) {
          label.classList.toggle("is-unlocked", reachedIndex >= 0 && i === reachedIndex);
        });

        // Celebrate only when a *new* reward step is crossed, not on every redraw.
        var previous = parseInt(progressEl.getAttribute("data-reached-index"), 10);
        if (isNaN(previous)) previous = -1;
        if (reachedIndex > previous) {
          var dot = dots[reachedIndex];
          progressEl.classList.remove("is-unlocking");
          if (dot) dot.classList.remove("is-unlocking");
          // Reflow so the animation restarts even on consecutive unlocks.
          void progressEl.offsetWidth;
          progressEl.classList.add("is-unlocking");
          if (dot) dot.classList.add("is-unlocking");
          window.setTimeout(function () {
            progressEl.classList.remove("is-unlocking");
            if (dot) dot.classList.remove("is-unlocking");
          }, 2700);
        }
        progressEl.setAttribute("data-reached-index", String(reachedIndex));

        var messageEl = progressEl.querySelector("[data-cart-progress-message]");
        if (messageEl) {
          if (next) {
            var remaining = next.qty - qty;
            var unit = Vandalism.Cart.progressUnit(remaining);
            messageEl.innerHTML =
              "Plus que <strong>" + remaining + " " + unit + "</strong> pour débloquer : " + next.label;
          } else {
            messageEl.textContent = projected
              ? "Avec cette sélection, tout est débloqué !"
              : "Toutes les récompenses sont débloquées !";
          }
        }
      });
    },

    changeLine: function (key, quantity) {
      var self = this;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // Une réponse d'erreur n'a pas la forme d'un panier : on relit /cart.js
          // plutôt que de rendre un objet incomplet et de laisser le tiroir figé.
          if (!cart || !cart.items) {
            self.refresh();
            return;
          }
          self.render(cart);
        })
        .catch(function () { self.refresh(); });
    },

    refresh: function (cb) {
      fetch("/cart.js")
        .then(function (res) { return res.json(); })
        .then(
          function (cart) {
            this.render(cart);
            if (cb) cb();
          }.bind(this)
        );
    },

    render: function (cart) {
      this.lastCart = cart;
      // Ces mises à jour sont annexes : si l'une échoue, les lignes du panier
      // doivent quand même être redessinées, sinon un retrait n'a aucun effet
      // visible et le tiroir semble cassé.
      var self = this;
      [
        function () { self.updateProgress(cart); },
        function () { self.updateRewardTotal(cart); },
        function () { self.updateRewardPickers(cart); },
        function () {
          if (window.Vandalism.refreshBundlePreview) window.Vandalism.refreshBundlePreview();
        },
      ].forEach(function (step) {
        try { step(); } catch (err) { /* une section annexe ne bloque pas le panier */ }
      });

      var countEls = document.querySelectorAll("[data-cart-count]");
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      var container = this.drawer && this.drawer.querySelector("[data-cart-items]");
      var emptyEl = this.drawer && this.drawer.querySelector("[data-cart-empty]");
      var footerEl = this.drawer && this.drawer.querySelector("[data-cart-footer]");
      if (!container) return;

      if (cart.item_count === 0) {
        container.innerHTML = "";
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;

      container.innerHTML = cart.items
        .map(function (item) {
          return (
            '<div class="cart-line">' +
            '<img class="cart-line__img" src="' + item.image + '&width=200" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
            '<div class="cart-line__info">' +
            '<div class="cart-line__head">' +
            "<p class=\"cart-line__title\">" + escapeHtml(item.product_title) + "</p>" +
            '<span class="cart-line__price">' +
            // Shopify splits a line when only part of it is discounted, so the
            // saving has to be visible on the line itself.
            (item.original_line_price > item.final_line_price
              ? '<s class="cart-line__price-was">' + Vandalism.formatMoney(item.original_line_price) + "</s> "
              : "") +
            Vandalism.formatMoney(item.final_line_price) + "</span>" +
            "</div>" +
            (item.variant_title ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + "</p>" : "") +
            '<div class="cart-line__row">' +
            '<div class="quantity-selector" data-quantity-selector>' +
            '<button type="button" class="quantity-selector__btn" data-quantity-step="-1">−</button>' +
            '<input class="quantity-selector__input" data-quantity-input data-cart-line-qty="' + item.key + '" type="number" min="0" value="' + item.quantity + '">' +
            '<button type="button" class="quantity-selector__btn" data-quantity-step="1">+</button>' +
            "</div>" +
            '<button type="button" class="cart-line__remove" data-cart-line-remove="' + item.key + '">Retirer</button>' +
            "</div>" +
            "</div>" +
            "</div>"
          );
        })
        .join("");

      // The subtotal text is owned by updateRewardTotal: when a discount
      // applies it holds the struck original, otherwise the plain total.
    },
  };

  window.Vandalism = window.Vandalism || {};
  // Matches the shop's Liquid money format ("49,99€") so JS-rendered prices sit
  // next to server-rendered ones without a formatting mismatch.
  window.Vandalism.formatMoney = function (cents) {
    var amount = (cents / 100).toFixed(2).replace(".", ",");
    return amount + "€";
  };
  window.Vandalism.Cart = Cart;

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initSearch();
    initReveal();
    initDragScroll();
    initAccordions();
    initProductGallery();
    initVariantPickers();
    initQuantitySteppers();
    initSizeGuard();
    initStickyAddToCart();
    Cart.init();
    initBundlePreview();
    initSwipeRails();
    initCartUpsellDismiss();
    initCollectionSort();
    initLocaleSelectors();
    initAnnouncementBar();
    initUgcLoop();
    initUgcVideos();
  });
})();
